import { render } from "./SchoolStatisticsByStream.vue?vue&type=template&id=af6eea58"
import script from "./SchoolStatisticsByStream.vue?vue&type=script&lang=js"
export * from "./SchoolStatisticsByStream.vue?vue&type=script&lang=js"
script.render = render

export default script